/** "Colegas mandam para mim" (docs/refactor/63): the switch's behaviour, shared by every place it shows. */

import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api, ApiError } from './api'
import { useI18n } from './i18n'
import { ConfirmIdentity } from '../components/ConfirmIdentity'

/** Set the switch, and the identity check that switching on may ask for. */
export function useTeamWorkToggle() {
  const { t } = useI18n()
  const queryClient = useQueryClient()
  const [confirming, setConfirming] = useState(false)
  const set = useMutation({
    mutationFn: (accept: boolean) => api.remote.setTeam(accept),
    onSuccess: () => {
      setConfirming(false)
      void queryClient.invalidateQueries({ queryKey: ['remote'] })
      void queryClient.invalidateQueries({ queryKey: ['teammates'] })
    },
    onError: (error, accept) => {
      if (accept && error instanceof ApiError && error.code === 'reauth_required') setConfirming(true)
    },
  })
  const dialog = confirming ? (
    <ConfirmIdentity why={t('team.reauthWhy')} onConfirmed={() => set.mutate(true)} onCancel={() => setConfirming(false)} />
  ) : null
  return { set, dialog }
}

